'use client'

import React, { useEffect, useState } from "react"
import Swiper from "@/components/ui/swiper/Swiper"
import Card from "@/features/accomodation/Card"
import { searchAccomodations } from "@/api/actions"

type OthersProps = {
    aroeven: Aroeven,
    accomodation: Accomodation
}

export default function Others({
    aroeven,
    accomodation
}: OthersProps) {

    const [others, setOthers] = useState<Accomodation[]>([])

    useEffect(() => {
        async function search() {
            const { items } = await searchAccomodations(aroeven, {
                ...aroeven.federation !== true && {
                    proposedBy: aroeven.slug
                },
                accomodationStatus: 'permanent'
            })
            setOthers(items.filter(other => other.id !== accomodation.id))
        }

        search()
    }, [])

    if (others.length === 0) {
        return <></>
    }

    return (
        <>
            <section className="suggestions bafa layout-pt-md layout-pb-md">
                <div data-aos="zoom-in-up" data-aos-duration={800} className="container">
                    <div className="row y-gap-10 justify-between items-end">
                        <div className="col-auto">
                            <h3 >Autres hébergements à découvrir</h3>
                            <h4>Les autres utilisateurs ont aussi regardé</h4>
                        </div>
                    </div>
                    <Swiper className={"vignette relative overflow-hidden pt-40 sm:pt-20 js-section-slider"}>
                        {others.map((other, indexOther) => {
                            return (
                                <React.Fragment key={'other-' + indexOther}>
                                    <div className="swiper-slide">
                                        <Card accomodation={other} />
                                    </div>
                                </React.Fragment>
                            )
                        })}
                    </Swiper>
                </div>
            </section>
        </>
    )
}